exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".anm_container {\r\n    /* margin: 50px 0 20px 20px; */\r\n    /* border: 1px solid #ccc; */\r\n    padding: 0 30px;\r\n}\r\n\r\n.anm_title {\r\n    padding: 30px 0 20px 0;\r\n    font-size: 15px;\r\n    border-bottom: 1px solid #ccc;\r\n}\r\n\r\n.anm_title_1 {\r\n    text-align: center;\r\n    font-size: 22px;\r\n}\r\n\r\n.anm_title_2 {\r\n    margin-top: 15px;\r\n    color: #999;\r\n    text-align: center;\r\n}\r\n\r\n.anm_content {\r\n    padding: 40px 0;\r\n    min-height: 200px;\r\n    font-size: 15px;\r\n    border-bottom: 1px dashed #ccc;\r\n    text-indent: 30px;\r\n    line-height: 25px;\r\n}\r\n\r\n.anm_content>div pre {\r\n    background: #ccc;\r\n    white-space: normal !important;\r\n}\r\n\r\n.anm_attachment {\r\n    padding: 20px;\r\n    font-size: 15px;\r\n}\r\n\r\n.anm_attachment ul li {\r\n    margin: 10px 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/anouncement-detail/anouncement-detail.component.css
// module id = ../../../../../src/app/home/components/anouncement-detail/anouncement-detail.component.css
// module chunks = main